"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GLTFConverter = void 0;
const GLTFConverter_1 = require("./GLTFConverter");
Object.defineProperty(exports, "GLTFConverter", { enumerable: true, get: function () { return GLTFConverter_1.GLTFConverter; } });
//# sourceMappingURL=index.js.map